import { useSelector } from 'react-redux';
import { selectUserProjectTimeZone } from 'core/userContext';

import { DATE_FORMAT_WITH_COMMA_HOUR_MINS, displayDate, displayDateTz } from 'utils/date';

export const EnteredJourneyTooltipContent = ({ date }: { date: Date }) => (
  <span>{displayDate(date, DATE_FORMAT_WITH_COMMA_HOUR_MINS)}</span>
);

export const LeavingTileTooltipContent = ({ date }: { date: Date }) => {
  const projectTimeZone = useSelector(selectUserProjectTimeZone);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return (
    <div>
      <div>{displayDate(date, DATE_FORMAT_WITH_COMMA_HOUR_MINS)}</div>

      <div>
        {displayDateTz(date, DATE_FORMAT_WITH_COMMA_HOUR_MINS, projectTimeZone)} (Project&apos;s
        time)
      </div>

      <div>
        {displayDateTz(date, DATE_FORMAT_WITH_COMMA_HOUR_MINS, userTimeZone)} (User&apos;s time)
      </div>
    </div>
  );
};
